const { SaveButton, Toolbar } = require("react-admin");

const CustomToolbar = ({ isSaving }) => (
  <Toolbar>
    <SaveButton disabled={isSaving} />
  </Toolbar>
);

export default CustomToolbar;
